import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'views.Shareholders.title',
    defaultMessage: 'Akcjonariat spółki'
  }
});



// WEBPACK FOOTER //
// ./src/views/Shareholders/ShareholdersView.intl.js